import { useEffect, useState } from "react";
import { fetchNPDonations } from "../../../api/Donations";
import { getAllPaginatedCampaigns } from "../../../api/Campaigns";
import NonprofitDonationTable from "./NonprofitDonationTable/NonprofitDonationTable";
import { useSelector } from "react-redux";
import Spinner from "../../shared/LoadingSpinner/Spinner";

async function fetchAllCampaigns(nonprofitId) {
  let page = 1;
  let allCampaigns = [];
  while (true) {
    const response = await getAllPaginatedCampaigns(page, "", nonprofitId);
    allCampaigns = [...allCampaigns, ...response.results];
    if (!response.next) break;
    page++;
  }
  return allCampaigns;
}

async function fetchAllDonations(nonprofitId) {
  let page = 1;
  let allDonations = [];
  while (true) {
    const response = await fetchNPDonations(nonprofitId, page);
    allDonations = [...allDonations, ...response.results];
    if (!response.next) break;
    page++;
  }
  return allDonations;
}

export default function NonprofitDonationList() {
  const [isLoading, setIsLoading] = useState(false);
  const [localUserData, setLocalUserData] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [donations, setDonations] = useState([]);
  const userData = useSelector((state) => state.userData.userData);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (Object.keys(userData).length !== 0) {
      setLocalUserData(JSON.parse(userData));
    }
  }, [userData]);

  useEffect(() => {
    if (!localUserData || !localUserData.nonprofit) return;

    setIsLoading(true);

    const fetchAll = async () => {
      try {
        const [allCampaigns, allDonations] = await Promise.all([
          fetchAllCampaigns(localUserData.nonprofit),
          fetchAllDonations(localUserData.nonprofit),
        ]);
        setCampaigns(allCampaigns);
        setDonations(allDonations);
      } catch (error) {
        console.error("Error fetching donations data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAll();
  }, [localUserData]);

  if (isLoading) {
    return (
      <div className="flex flex-row ml-auto mt-[25vh] w-full h-full justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="flex-1 bg-gray-100 min-h-screen p-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="!text-[30px] !font-bold !font-poppins text-blue-navy text-left mb-6">
          Donations
        </h1>

        {campaigns.length === 0 ? (
          <div className="bg-white rounded-2xl shadow-md p-8 text-center text-sm text-gray-400">
            No campaigns yet.
          </div>
        ) : (
          campaigns.map((campaign) => {
            const campaignDonations = donations.filter(
              (d) => d.campaign_title === campaign.campaign_title
            );
            return (
              <NonprofitDonationTable
                key={campaign.id}
                name={campaign.animal_name || campaign.campaign_title}
                data={campaignDonations}
              />
            );
          })
        )}
      </div>
    </div>
  );
}
